import {put, takeEvery} from "redux-saga/effects";

function* savePublicContext(action) {
  try {
    yield put({type: 'SAVE.PUBLIC_CONTEXT.SUCCESS', params:action.params});
  } catch (error) {
    yield put({type: 'SAVE.PUBLIC_CONTEXT.FAILURE', error});
  }
}

export function* watchSavePublicContext() {
  yield takeEvery('SAVE.PUBLIC_CONTEXT.REQUEST', savePublicContext)
}
